import React from 'react'

import { Button, Modal } from 'src/chrome'
import { Item } from 'src/campaign_store/types'

type ProductPreviewModalProps = {
  product: Item
  onClose: () => void
  onPurchase: (product: Item) => void
}

const ProductPreviewModal: React.FC<ProductPreviewModalProps> = props => {
  const { product, onClose, onPurchase } = props
  const bodyChildren = (
    <div>
      <p style={{ marginBottom: 30 }}>{product.description}</p>
      <span style={{ fontSize: '2.25rem', fontWeight: 500 }}>
        Price:{' '}
        <span
          style={{
            marginLeft: 15,
            fontSize: '3rem',
            color: '#fb5e9c',
          }}
        >
          {product.price}
        </span>
      </span>
    </div>
  )
  const footerChildren = (
    <div>
      <Button
        title={'Buy'}
        style={{ marginLeft: 'auto', width: 126 }}
        onClick={() => onPurchase(product)}
      />
    </div>
  )

  return (
    <div>
      <Modal
        title={product?.name ?? 'Product'}
        imageUrl={product.image ?? undefined}
        bodyChildren={bodyChildren}
        footerChildren={footerChildren}
        onClose={onClose}
        animationStyle={'fade'}
      />
    </div>
  )
}

export default ProductPreviewModal
